/* elu-contact.js — pagina Contact (sections/elu-contact.liquid): mesajele de validare în română, lângă fiecare câmp
   (formularul are novalidate, deci browserul nu mai afișează mesajele lui, în limba browserului). Idempotent: window.__eluBound.contact. */
(function () {
  window.__eluBound = window.__eluBound || {};
  if (window.__eluBound.contact) return;
  window.__eluBound.contact = true;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function errEl(f) { var id = f.getAttribute("aria-describedby"); return id ? document.getElementById(id) : null; }
  function check(f) {
    var ok = f.type === "checkbox" ? f.checked : f.value.trim() !== "" && (f.type !== "email" || EMAIL.test(f.value.trim()));
    var e = errEl(f);
    if (ok) { f.removeAttribute("aria-invalid"); if (e) e.textContent = ""; }
    else { f.setAttribute("aria-invalid", "true"); if (e) e.textContent = f.getAttribute("data-msg") || "Completează acest câmp."; }
    return ok;
  }
  function bind(form) {
    var fields = form.querySelectorAll("[required]");
    form.addEventListener("submit", function (ev) {
      var first = null;
      fields.forEach(function (f) { if (!check(f) && !first) first = f; });
      if (first) { ev.preventDefault(); first.focus(); }
    });
    fields.forEach(function (f) {
      f.addEventListener(f.type === "checkbox" || f.tagName === "SELECT" ? "change" : "blur", function () { if (f.getAttribute("aria-invalid")) check(f); else if (f.value && f.type === "email") check(f); });
    });
    var ok = form.querySelector(".elu-contact__ok");
    if (ok) ok.focus();
  }
  function init() { var form = document.getElementById("elu-contact-form"); if (form) bind(form); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
